import React from "react";
import QuestionButton from "../questionButton/questionButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setCurrent,
} from "../../redux/features/questions/questionSlice";
import xss from "xss";
import { submitTheory } from "../../redux/activityAsyncAction";

const QuestionButtonsContainer = () => {
  const dispatch = useDispatch();
  const { list, currentIndex, activeTab } = useSelector(
    (state) => state.questions
  );

  const handleQuestionChange = (i) => () => {
    const currentQuestion = list[currentIndex];
    if (currentQuestion.type === "theory") {
      dispatch(submitTheory(currentIndex));
    }
    const nextQuestion = list[i];
    if (nextQuestion.type === "theory" && !(activeTab === "theory")) {
      dispatch(setActiveTab("theory"));
    }
    if (nextQuestion.type === "multichoice" && !(activeTab === "multichoice")) {
      dispatch(setActiveTab("multichoice"));
    }
    //current question has to have a type theory
    dispatch(setCurrent(Number(i)));
  };
  // console.log(currentQuestion);
  return (
    <div className="question-btn-container d-flex flex-wrap px-3 pt-2 pb-5">
      {list.map((question, i) => (
        <QuestionButton
          handleQuestionChange={handleQuestionChange(i)}
          variant={
            currentIndex === i
              ? "current"
              : question.type === "multichoice"
              ? question.answer?.length
                ? "answered"
                : "unanswered"
              : question.type === "theory"
              ? xss(question.answer, {
                  whiteList: {},
                  stripIgnoreTag: true,
                  stripIgnoreTagBody: ["script"],
                }).trim()
                ? "answered"
                : "unanswered"
              : "unanswered"
          }
          key={i}
          number={`${i + 1}`}
        />
      ))}
    </div>
  );
};

export default QuestionButtonsContainer;
